import { development, releaseName } from 'app/config/constants'
import { when } from 'mobx'
import { store } from 'store/store'
import { Meta } from 'type/Options'
import { postMessageSelf } from 'util/message'

function getParams(): Record<string, string> {
  const params = Object.fromEntries(new URLSearchParams(location.search))
  if (development && !Object.entries(params).length) {
    Object.assign(params, {
      company: 'mosaica_internal',
      access: 'demo',
      lang: 'en',
      item: '01f5fe4d',
    })
  }
  return params
}

function getMeta(): Meta {
  return {
    location: location.href,
    self: true,
  }
}

function getOptions(): object {
  const { product, company, client, shop, access, user, lang } = getParams()
  const inline = true
  return { inline, product, company, client, shop, access, user, lang }
}

function getOpen(): object {
  const { item } = getParams()
  return { item }
}

async function go() {
  console.info('try on', releaseName)
  const options = getOptions()
  const meta = getMeta()
  const open = getOpen()
  postMessageSelf('setup', { options, meta })
  await when(() => store.setupDone)
  postMessageSelf('open', open)
}

export function inline() {
  const { pathname } = location
  const fit = pathname === '/inline'
  if (fit) void go()
}
